export const appUiIds = {
  request: {
    title: 'UI000578',
    description: 'UI000579',
    inputLabel: 'UI000337',
    invalidEmail: 'UI004728',
    buttonName: 'UI000580',
  },
  requested: {
    title: 'UI004729',
    description: 'UI000581',
    buttonName: 'UI000547',
  },
  emailNotRecognized: {
    title: 'UI005439',
    description: 'UI005440',
    buttonName: 'UI000547',
  },
  sailorServices: 'UI000550',
  setNewPassword: {
    title: 'UI000834',
    inputLabel: 'UI000360',
    hint1: 'UI000361',
    hint2: 'UI000362',
    hint3: 'UI000363',
    hint4: 'UI003886',
  },
  setSuccessfully: {
    title: 'UI001312',
    description: 'UI001313',
  },
  setWithError: {
    title: 'UI000832',
    description: 'UI004730',
    buttonName: 'UI000580',
  },
  claimBooking: {
    awkwardSubtitle: 'UI000549',
    awkwardTitle: 'UI000548',
    title: 'UI000537',
    enterDetails: 'UI001769',
    notFoundTitle: 'UI005429',
    notFoundSubtitle: 'UI005430',
    contactSailorServices: 'UI000550',
    enterManually: 'UI005431',
    selectEmailTitle: 'UI005426',
    selectEmailSubtitle: 'UI005427',
    foundBookingTitle: 'UI005433',
    foundBookingSubtitle: 'UI005434',
    reservationDetails: 'UI005424',
    verifyDetailsTitle: 'UI005422',
    verifyDetailsSubtitle: 'UI005423',
    bookingReference: 'UI000546',
    next: 'UI001944',
    claimYourBooking: 'UI005806',
    enterDetailsManualEntry: 'UI005807',
    reclaimScreenSubText: 'UI005932',
    deactivatedAccounts: 'UI005933',
    deactivatedAccountsSubtext: 'UI005934',
    successPleaseLogIn: 'UI005935',
    successSubtext: 'UI005936',
    logout: 'UI005937',
    whyThisHappened: 'UI005940',
    missingDobTitle: 'UI005971',
    missingDobSubtext: 'UI005972',
  },
  commonLabels: {
    cancel: 'UI005118',
    ok: 'UI000547',
    search: 'UI005543',
    done: 'UI001947',
    gotIt: 'UI005873',
    next: 'UI001944',
  },
  importation: {
    importing: 'UI005961',
    tryReloadingText: 'UI005962',
    reloadReservation: 'UI005963',
    tryAgainText: 'UI005964',
    connectBooking: 'UI005965',
    thatsAwkward: 'UI005966',
  },
};

export type AppUiIds = typeof appUiIds;
